import { useTranslation } from 'react-i18next'
import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { HoursReportStatuses } from '@/types'

type HoursReportStatusMultiSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
}

export const HoursReportStatusMultiSelect = ({
  value,
  onChange,
}: HoursReportStatusMultiSelectProps): JSX.Element => {
  const { t } = useTranslation('forms')

  const options = Object.keys(HoursReportStatuses).map((key) => {
    const status = HoursReportStatuses[
      key as keyof typeof HoursReportStatuses
    ] as string

    return {
      label: t(`hoursReportStatus.${status}`),
      value: status,
    } as SearchAutocompleteOption
  })

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={options}
      placeholder={t(`placeholders.hoursReportStatus`)}
      sort={false}
      fieldSx={{ width: 280 }}
    />
  )
}
